<ng-container *transloco="let t">
  <ng-container [formGroup]="editForm">
    <ng-container formGroupName="config">
      <div class="row">
        <div class="col-6">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label for="result">{{t('outcome-edit.result')}}</mat-label>
            <mat-select formControlName="result">
              <mat-option [value]="true">{{t('common.success')}}</mat-option>
              <mat-option [value]="false">{{t('common.fail')}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label for="progress">{{t('outcome-edit.progress')}}</mat-label>
            <input type="number" matInput formControlName="progress" />
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label for="defaultOutputValue">{{t('outcome-edit.defaultOutputValue')}}</mat-label>
            <input type="text" matInput formControlName="defaultOutputValue" />
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label for="sourceProcedureStepId">{{t('outcome-edit.sourceProcedureStepId')}}</mat-label>
            <mat-select formControlName="sourceProcedureStepId">
              <mat-option></mat-option>
              <mat-option *ngFor="let step of steps$ | async" [value]="step.id">{{step.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
